<div *ngIf="busy">Fetching data...</div>

<div *ngIf="!busy" class="rounds">
  <ng-container *ngFor="let r of arr2D; let i = index">
    Round {{i+1}} - {{getDateRange(i)}}


    <table class="table table-bordered table-striped" *ngIf="!isDoubles">
      <thead class="thead-green">
        <tr>
          <th width="50%">Player</th>
          <th width="1%" style="text-align: center;">v</th>
          <th width="50%">Player</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let r2 of r">
          <tr>
            <td [ngClass]="{'bold': fullName == r2.player1Name}">{{r2.player1Name}}</td>
            <td></td>
            <td [ngClass]="{'bold': fullName == r2.player2Name}">{{r2.player2Name}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>


    <table class="table table-bordered table-striped" *ngIf="isDoubles">
      <thead class="thead-green">
        <tr>
          <th width="50%">Team</th>
          <th width="1%" style="text-align: center;">v</th>
          <th width="50%">Team</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let r2 of r">
          <tr>
            <td [ngClass]="{'bold': player.doublesName == r2.team1Name}">{{r2.team1Name}}</td>
            <td></td>
            <td [ngClass]="{'bold': player.doublesName == r2.team2Name}">{{r2.team2Name}}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>



  </ng-container>

</div>